module.exports = __webpack_public_path__ + "static/media/32_JessicaSoyk_webfinal.7885e1ff.jpg";